/**
 * Enum to hold operators for all search select fields
 */
export enum HisSelectOperatorType {
    EQUAL = '=',
    UNEQUAL = '≠'
}
